import { Model } from '@vuex-orm/core'

export const ADMIN = 'admin'
export const ENGINEER = 'localadmin'
export const STUDENT = 'user'

export const STATUS_APPROVED = 'APPROVED'
export const STATUS_DECLINED = 'DECLINED'
export const STATUS_IN_REVIEW = 'IN-REVIEW'

export default class Role extends Model {
    static get entity () {
        return 'roles'
    }

    static fields () {
        return {
            id: this.uid(),
            name: this.string(''),
            sysname: this.string(''),
        }
    }
}
